export function centerPopup(url: string, title: string, w: number, h: number) {
  const left = window.screen.width / 2 - w / 2;
  const top = window.screen.height / 2 - h / 2;
  return window.open(
    url,
    title,
    'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left,
  );
}
